import * as React from "react";
import { PropertyFiltersGroupProps } from "../../typings";
import { withStores } from "stores";
import { UitkExpandoPeek } from "uitk-react-expando";
import { UitkHeading } from "uitk-react-text";
import { PROPERTY_FILTERS } from "../../PropertyFilters";
import { PropertyFilterInDialog } from "components/flexComponents/PropertyFilters/dialog/PropertyFiltersDialog";
import { useLocalization } from "@shared-ui/localization-context";
import {
  Action,
  FlexTrackingInfo,
  sendDelayedClickstreamTrackEvent,
} from "components/utility/analytics/FlexAnalyticsUtils";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkSpacing } from "uitk-react-spacing";
import { observer } from "mobx-react";
import { DesktopPropertyFiltersStores, WithApplyProp } from "./types";

type SimplePropertyFiltersProps = Pick<DesktopPropertyFiltersStores, "propertyFilters"> & WithApplyProp;

export const SimplePropertyFilters = withStores("propertyFilters")(
  observer((props: SimplePropertyFiltersProps) => {
    const { propertyFilters, apply } = props;
    const { formatText } = useLocalization();
    const onApply: React.FormEventHandler = (e) => {
      e.preventDefault();
      apply("apply");
    };

    return (
      <UitkSpacing padding={{ inline: "three" }}>
        <div>
          <UitkSpacing padding={{ blockstart: "two", blockend: "six" }}>
            <UitkHeading level={2} size={500}>
              {formatText("propertyfilters.filterBy")}
            </UitkHeading>
          </UitkSpacing>
          <form className="SortAndFilters" onChange={onApply}>
            {propertyFilters.getListOfFilters().map((filter, index) => (
              <PropertyFiltersGroup key={`${filter.name}-${index}`} filter={filter} headerSize={300} />
            ))}
          </form>
        </div>
      </UitkSpacing>
    );
  })
);

/**
 * Represents a filter group (e.g. Popular Filters)
 * @param props
 * @constructor
 */
const PropertyFiltersGroup = (props: PropertyFiltersGroupProps) => {
  const { filter } = props;
  const { formatText } = useLocalization();
  const track = useClickTracker();

  const callback = (filterNameAndShowMoreOrLess: string) => {
    const flexTracking: FlexTrackingInfo = {
      moduleName: PROPERTY_FILTERS,
      rfrr: filterNameAndShowMoreOrLess, // e.g. stars.ShowMore
      action: Action.CLICK,
    };

    sendDelayedClickstreamTrackEvent(flexTracking, track);
  };

  return (
    <UitkSpacing padding={{ blockend: "six" }}>
      <UitkExpandoPeek
        collapseHeight={360}
        collapseLabel={formatText("propertyfilter.seeLess")}
        expandLabel={formatText("propertyfilter.seeMore")}
        analytics={{
          id: filter!.name,
          callback,
        }}
      >
        <PropertyFilterInDialog {...props} />
      </UitkExpandoPeek>
    </UitkSpacing>
  );
};
